import service from '@/utils/server';

const modName='/bd/report/storageAssignAdjustingRecords/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/report/storageAssignAdjustingRecords/api/index.js